<template>
	<v-dialog v-model="dialog" persistent max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>{{'modify' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-card-title class="text-start subtitle-1 pt-6 text-pre-wrap">
				{{'Changing trademark counts in the' | localize}} <span class="secondary--text">{{ name }}</span>
			</v-card-title>
			<v-divider />
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" lazy-validation>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-select dense
								v-model="trademark"
								:items="teamTrademarks"
								item-text="name"
								multiple
								color="secondary"
								item-color="secondary"
								:label="'Trademarks' | localize"
								@change="onceMore()"
								:rules="[rules.not_empty]">
							</v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="secondary"
								:label="'Entry fee' | localize"
								v-model.number="entry_fee"
								name="entry_fee"
								type="text"
								readonly
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="secondary"
								:label="'Annual flat fee' | localize"
								v-model.number="annual_fee"
								name="annual_fee"
								type="text"
								readonly
								@change="onceMore()">
							</v-text-field>
						</v-col>
					</v-row>	
				</v-form>
				</v-container>
				<v-row v-if="error" class="text-center mx-2 error--text">{{'Error' | localize }} => {{ error }}</v-row>
				<v-row class="text-start text-pre-wrap mx-2">{{ message }}</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize" 
					:disabled="!valid || loading || changed"
					@click="calculate">
					{{'Calculate' | localize}}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="!changed || Boolean(error)"
					@click="changeChannel">
					{{'Save' | localize}}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" 
					@click="closeDialog">
					{{'Close' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import localizeFilter from '../../../filters/localize.filter';
import { localeNumber } from '../../../functions/common';

	export default {
		props: ['chain', 'channel'],
		data () {
			return	{
				dialog: false,
				valid: false,
				changed: false,
				message: '',
				error: '',
				rules: {
					number: v => /^[+]?[0-9]/.test(v) || localizeFilter('its expected number'),
					not_empty: v => v.length > 0 || localizeFilter('select min 1 item'),
				},
				//props
				trademark: this.channel.trademarks,
				name: this.chain.name,
				entry_fee: this.channel.entry_fee * this.channel.trademarks.length,
				annual_fee: this.channel.annual_fee * this.channel.trademarks.length,

				toAdd: [], //trademarks of channel
				toRemove: [], //trademarks from the channel
			}
		},
		computed: {
			loading() {
				return this.$store.getters.loading
			},
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game;
			},
			team() {
				return this.$store.getters.team;
			}, 
			trademarks () {
				return this.$store.getters.trademarks
			},
			teamTrademarks() {
				let res = [];
				if (this.team) {
					const arr = [];
					this.team?.products.map(prod => {
						const inArr = arr.find(it => it === prod.trademarkId)
						if (!inArr) {
							arr.push(prod.trademarkId)
						}
					})
					res = this.trademarks.filter(it => arr.indexOf(it.id) !== -1)
				}
				return res
			}
		},
		methods: {
			onceMore() {
				this.error ='';
				this.changed = false;
				this.message = '';	
			},
			formatNumber(num) {
				return localeNumber(num, this.locale);
			},
			calculate() {
				if (this.$refs.form.validate()) {

					if (this.trademark.length == this.channel.trademarks.length) {
						return this.error = localizeFilter(`no parameters have been changed`);
					}

					const trademarksList = this.trademark;
					const trademarksChan = this.channel.trademarks;
 
					if (trademarksList?.length > trademarksChan?.length) {
						//add trademark(s) to channel
						trademarksList.forEach(item => {
							const inChannel = trademarksChan.find(tr => tr.name == item)
							if (!inChannel) {
								this.toAdd.push(item)
							}
						})
						const num = this.trademark.length;
						this.entry_fee = this.chain.entry_fee * num;
						this.annual_fee = this.chain.annual_fee * num;
						
						//console.log(this.toAdd)
						const trs = this.toAdd.join(' ');
						/* locale - massages*/
						if (this.locale == 'ro-RO') {
							
							this.message = `Vă rugăm să luați notă de taxă de intrare și de taxă anuală fixă
									--------------------------------------------------------------------------
						Dacă doriți să adăugați mărc(i) comerciale: ${trs}, apăsați butonul "Salvare", altfel - apăsați "Închide"`
						} 
						else if (this.locale == 'ru-RU') {
							
							this.message = `Пожалуйста, обратите внимание на значения вступительного взноса и ежегодной фиксированной платы
									--------------------------------------------------------------------------
						Если хотите добавить торговые марки: ${trs}, нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
						}
						else {
							
							this.message = `Please, take note of the entry fee and annual flat fee
									--------------------------------------------------------------------------
						If you want to add trademark(s): ${trs}, press the button "Save", else - press "Close"`
						}
					}
					else {
						//remove trademark(s) from the channel
						trademarksChan.forEach(item => {
							const inChannel = trademarksList.find(tr => tr == item.name)
							if (!inChannel) {
								this.toRemove.push(item.name)
							}
						})

						const trs = this.toRemove.join(', ');
						const num = this.trademark.length;
						const new_entry_fee = this.chain.entry_fee * num;
						this.entry_fee = (this.channel.entry_fee > 0) ? new_entry_fee : 0;
						this.annual_fee = this.chain.annual_fee * num;

						/* locale - massages*/
						if (this.locale == 'ro-RO') {
							this.message = `Vă rugăm să luați notă de taxă de intrare și de taxă anuală fixă
									--------------------------------------------------------------------------
						Dacă doriți să ștergeți mărcile comerciale: ${trs} de pe canal, apăsați butonul "Salvare", altfel - apăsați "Închide"`
						} 
						else if (this.locale == 'ru-RU') {
							this.message = `Пожалуйста, обратите внимание на значения вступительного взноса и ежегодной фиксированной платы
									--------------------------------------------------------------------------
						Если хотите удалить торговые марки: ${trs}, из канала, нажмите кнопку "Сохранить", иначе — кнопку "Закрыть"`
						}
						else {
							this.message = `Please, take note of the entry fee and annual flat fee
										--------------------------------------------------------------------------
							If you want to remove trademark(s): ${trs},from the channel, press the button "Save", else - press "Close"`
						}
					}

					this.changed = true;
				}
			},	
			async changeChannel () {
				if (this.trademark !== this.channel.trademarks) {

					const channel = {
						id: this.channel.id,
						stores: this.channel.stores,
						entry_fee: this.entry_fee,
						annual_fee: this.annual_fee,
					}
					await this.$store.dispatch('editChannel', channel);
				
					if (this.toRemove.length > 0) {
						//if trademark include spesial signs like as $, %, + ...  => encodeURIComponent()
						this.toRemove.forEach(async (trademark) => {
							//console.log(encodeURIComponent(trademark))
							this.removeTrademark(encodeURIComponent(trademark))
						});
					}
					else if (this.toAdd.length > 0) {
						this.toAdd.forEach(trademark => {
							this.addTrademarktoChannel(trademark)
						})
					}
					this.closeDialog()
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
				this.message = ''
				this.selected = this.channel.trademarks;
				this.changed = false;
				//resert
				this.entry_fee = this.channel.entry_fee * this.channel.trademarks.length;
				this.annual_fee = this.channel.annual_fee * this.channel.trademarks.length;
				this.trademark = this.channel.trademarks;
				
				this.toAdd = []; 
				this.toRemove = []; 

			},
			async addTrademarktoChannel(trademark) {
				const obj = {
					channelId: this.channel.id,
					trademark: trademark
				}
				await this.$store.dispatch('addTrademarkToChannel', obj);
			},
			async removeTrademark(trademark) {
				const obj = {
					channelId: this.channel.id,
					trademark: trademark
				}
				await this.$store.dispatch('removeTrademarkFromChannel', obj);
			},
		},
	}
</script>